export default __webpack_public_path__ + "static/media/dont-miss-out.b6f3e4de.webp";